module.exports = __webpack_public_path__ + "static/concrete-section-uls-880x880-9ab837ece822bb89af2042428ff07f98.png";